import { render } from "./DocumentMetadata.vue?vue&type=template&id=b7630232&scoped=true"
import script from "./DocumentMetadata.vue?vue&type=script&lang=js"
export * from "./DocumentMetadata.vue?vue&type=script&lang=js"

import "./DocumentMetadata.vue?vue&type=style&index=0&id=b7630232&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7630232"]])

export default __exports__